export const SET_ADD_PASSENGER_WALLET = 'SET_ADD_PASSENGER_WALLET';

export const actionSetAddPassengerWallet = wallet => ({
    type: SET_ADD_PASSENGER_WALLET,
    payload: wallet
})
